export default "/imgs/promo-cross-white.png"